import { ChevronRight, Clock } from 'lucide-react';
import { PENDING_BADGE, insuranceHeadline } from 'components/Appointment/ConfirmAppointmentModal/helper';
import { VERIFICATION_STATUS } from 'components/Profile/Insurance/helper';
import { getStepById } from 'pages/Profile/helper';
import { CARD, PENDING_MESSAGES } from './helper';

const Insurance = ({ insurance, completed, onView }) => {
  const carrier = insurance?.active ? insurance.insurance_company?.data?.attributes : null;
  const status = insurance?.active ? VERIFICATION_STATUS[insurance.verification_status] : null;
  const { icon: Icon, iconBg, iconColor } = getStepById('insurance');

  return (
    <button
      type="button"
      onClick={onView}
      aria-label="View insurance details"
      className={`${CARD} flex w-full items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-secondary-50`}
    >
      {carrier?.logo_url ? (
        <img src={carrier.logo_url} alt={carrier.title || 'Insurance carrier'} className="h-9 w-9 shrink-0 rounded-xl object-cover" />
      ) : (
        <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${iconBg}`}>
          <Icon size={16} className={iconColor} />
        </div>
      )}

      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <p className="text-xs text-secondary-400">Insurance</p>

          {!completed && (
            <span className={PENDING_BADGE}>
              <Clock size={10} />
              Pending
            </span>
          )}

          {status && (
            <span className={`inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${status.light}`}>
              <status.icon size={10} />
              {status.label}
            </span>
          )}
        </div>

        <p className="line-clamp-2 break-words text-[13px] font-bold text-secondary-900">
          {insurance ? insuranceHeadline(insurance) : PENDING_MESSAGES.insurance}
        </p>
      </div>

      <ChevronRight size={16} className="shrink-0 text-secondary-400" />
    </button>
  );
};

export default Insurance;
